import React, { useContext, useEffect, useState } from "react";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import Footer from "./footer";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";

function Foodlicence() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);


   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email_address: '', user_phone_number: '', user_city: '' })
   const [errors, setErrors] = useState({});
      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 14);

   const validateForm = () => {
      const newErrors = {};

      // Name validation
      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }

      // Email validation
      if (!newData.user_email_address.trim()) {
         newErrors.user_email_address = 'Email address is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
         newErrors.user_email_address = 'Enter a valid email address.';
      }

      // Phone number validation
      // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
      //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
      // }

      if (!newData.user_phone_number.trim()) {
         newErrors.user_phone_number = 'number is required.';
       } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
         newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
       }


      // City validation
      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
   };

 

    const formPutPartenshipdeed = async (e) => {
                e.preventDefault();

                    // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
                if (!validateForm()) return;
              
                localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                 
              };

   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">FSSAI Registration </h1>
                        <h2>(Food Licence)</h2>
                        <p className="pdrl-text">Get FSSAI Registration  for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">A valid food license ensures consumer safety, compliance with regulations, and strengthens your brand’s credibility. With Dm2Legal, easily obtain your food license from home and launch your business with confidence!</p>
                        <p className="pd-text">An FSSAI food license ensures safety and compliance. Small businesses with a turnover under ₹12 lakhs get a basic license, upgrading to a state license once turnover exceeds ₹12 lakhs.</p>

                        <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only<span><br />(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label>{errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text">Starting a food business? A food license is mandatory for everyone involved, from raw material procurement to manufacturing, packaging, and sales. Whether you run a restaurant, canteen, or food distribution service, compliance is essential. Our expert team simplifies the registration process, ensuring a hassle-free experience for you.</p>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/Food-Licence.png" alt="" />
                     </div>
                  </div>
               </div>
               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">

                        <h2 className="text-center">Importance of FSSAI Registration for Food Businesses  </h2>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">

                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Provides Compliance with Regulations</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Ensures Health and Safety</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Enhances Trust and Credibility</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Decreased Risk</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Positive Media Coverage</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Global Competitive Advantage</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Customer Retention</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Provides Legal Protection</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <img src="assets/img/images/Benefits-of-FSSAI-RegistrationLicense.png" alt="" />
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Online FSSAI Registration
                           Application: <br />Step-by-Step Guide  </h2>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Determine Your Eligibility:
                                 <div className="space20"></div>
                                 <p className="pd-text">Determine the proper type of FSSAI registration or Licence according to the business turnover and scale.</p>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Choosing the Appropriate Application Form:
                                 <div className="space20"></div>
                                 <p className="pd-text">Choose the Proper FSSAI registration form based on your eligibility:</p>
                                 <ul >
                                    <li className="font-f-7 "><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Form A: Basic Registration</li>
                                    <li className="font-f-7 "><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Form B: State Licence and Central Licence</li>
                                 </ul>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Complete the Application Form:
                                 <div className="space20"></div>
                                 <p className="pd-text">Complete the application form with proper and correct information about the food business. It generally includes details of business, address, type of food, ownership and other information.                      </p>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Submitting the Application:
                                 <div className="space20"></div>
                                 <p className="pd-text">Submit the completed application with the additional documents to the relevant FSSAI office.</p>
                              </li>
                              <hr />
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Payment of Fees:
                                 <div className="space20"></div>
                                 <p className="pd-text">Pay the required fees for your FSSAI registration/Licence. The fee amount depends on the type and duration of the Licence.</p>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inspection:
                                 <div className="space20"></div>
                                 <p className="pd-text">FSSAI authorities will conduct an inspection of the food premises to verify the compliance of food premises according to the safety standards. Before conducting inspection they will communicate for scheduling this Inspection</p>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Issuance of Certificate:
                                 <div className="space20"></div>
                                 <p className="pd-text">Once this application is approved and compliance is done, the FSSAI issues your registration/licence. This contains a unique FSSAI Registration/Licence number.</p>
                              </li>
                              <hr />
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Displaying the FSSAI Logo:
                                 <div className="space20"></div>
                                 <p className="pd-text">Once acquired the FSSAI registration/licence its mandatory to display the FSSAI logo/number on your food product labels or in the food business premises.</p>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>


            </div>
         </div>


         <div className="service-binifits9 sp0" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center"> FSSAI Registration vs FSSAI Registration
                           Application: Differences and Benefits   </h2>
                        <div className="pro-llp-com-table">
                           <table>
                              <thead>
                                 <tr className="table-heading">
                                    <th>Specific</th>
                                    <th>FSSAI Registration</th>
                                    <th>FSSAI/FSSAI Registration
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>Form Required</td>
                                    <td>Form A</td>
                                    <td>Form B</td>
                                 </tr>
                                 <tr>
                                    <td>Type of Registration</td>
                                    <td>Basic</td>
                                    <td>Central and State License</td>
                                 </tr>
                                 <tr>
                                    <td>Size of Business</td>
                                    <td>Small Business</td>
                                    <td>Medium and Large</td>
                                 </tr>
                                 <tr>
                                    <td>Turnover Limit</td>
                                    <td>Businesses having an annual turnover not exceeding Rs.12 lakh</td>
                                    <td>Businesses having an annual turnover of more than Rs.12 lakh</td>
                                 </tr>
                                 <tr>
                                    <td>Duration</td>
                                    <td>On applicability</td>
                                    <td>Maximum 5 Years</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="bg-white">
            <div className="container">
               <div className="row">

                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Benefits of FSSAI Registration/License  </h2>
                     </div>
                  </div>

                  <div className="col-lg-6">

                     <div className="space30"></div>
                     <div className="space30"></div>
                     <div className="contact6-list doc-list" >
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Quality and Safety Assurance</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Legal Compliance</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Market Access</li>

                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="space30"></div>
                     <div className="space30"></div>
                     <div className="contact6-list doc-list" >
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consumer Awareness</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Regular Inspections</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consumer Protection</li>
                        </ul>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Documents Required for GST Registration</h2>
                        <div className="space40"></div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Sole Proprietorship / Individual</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of the sole proprietor</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <p>Own office:  Office address proof:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental Agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>Partnership deed / LLP Agreement</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Deed / Agreement Firm PAN Card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>HUF</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar card of Karta</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Karta</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photo of Applicant</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of HUF</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; HUF Deed Document</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>

               </div>
               <div className="row">

                  <div className="col-lg-6">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>Society / Trust / Club</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photo of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Society / Club / Trust</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Registration</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Proof of authorized signatory- Board Resolution</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>Private limited / Public limited / One person company</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar card of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Company’s PAN card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Registration</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; MOA (Memorandum of Association)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; AOA (Articles of Association)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Proof of authorized signatory- Board Resolution</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white"  >
            <div className="space40"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">The Process of FSSAI Registration for FSSAI Registration
                        </h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Determine Your Eligibility</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Obtain the Application Form</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Complete the Application Form</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Gather Supporting Documents</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Submit the Application</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Payment of Fees</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Inspection</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Issuance of Certificate</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Display the FSSAI Logo</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space80"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 " id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space50"></div>
                        <h2 className="text-center">Registration Process</h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>To ensure your safety, our team will review the documents you’ve submitted to check for any misleading or incorrect information.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our expert FSSAI professionals are here to assist you with document and licensing requirements.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>The appropriate expert will review your documents to process your food license application.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>If the application is approved, your company will be registered with the FSSAI.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>It is best to wait until our expert contacts you to confirm that your license has been issued.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>



         <div className="bg-white">

            <div className="container ">


               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Common Mistakes to Avoid in FSSAI Registration</h2>
                     </div>
                  </div>
                  <div className="col-lg-7">
                     <div className="space40"></div>
                     <div className="contact6-list doc-list">
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Incomplete Application Form</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Lack of Proper Documentation</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Non-compliance with the FSSAI Regulations</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inadequate Food Safety Management</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Poor Infrastructure</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inaccurate and Insufficient Labeling</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Failure to Maintain Proper Records</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Incorrect Categorization of Food Business</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/Common-Mistakes-to-Avoid-in-Food-Licence-Registration-.png" alt="" />
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs on FSSAI Registration</h2>
                              <div className="space20"></div>


                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1. Why is Food License Registration important?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Food License Registration ensures food safety, maintains legal compliance, builds consumer trust, and allows businesses to operate legally under FSSAI regulations.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2. How to register for a Food License?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">To register for a Food License, you need to:</p>
                                       <ol>
                                          <li>Submit application through the FSSAI portal.</li>
                                          <li>Provide business details, address proof, and food safety management documents.</li>
                                          <li>Selection of license type</li>
                                          <li>Complete the fees payment and await FSSAI approval.</li>

                                       </ol>
                                       The process typically takes 7-15 days.
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3. What are the types of FSSAI License Registration?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Basic Registration: For small food businesses with low turnover</p>
                                       <p className="font-f-3 weight-500">State License: For medium-sized food businesses.</p>
                                       <p className="font-f-3 weight-500">Central License: For large-scale food businesses, including importers.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4. How to renew your FSSAI license?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">To renew your FSSAI license, you need to:<br />

                                          Log in to the FSSAI portal.<br />
                                          Submit a renewal application before the license expiry date.<br />
                                          Provide required documents and fees for processing.<br />
                                          Await approval and receive your renewed license.<br />
                                          It’s advisable to apply at least 30 days before the expiration. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5. Who needs an FSSAI license in India?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Any food business operator involved in manufacturing, processing, packaging, or distributing food products, including restaurants, caterers, retailers, and importers, must obtain an FSSAI license.</p>


                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6. What is the food license number?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          The food license number is a unique identifier issued by FSSAI after registration, used to track food businesses and ensure compliance with food safety standards                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7. What are the criteria for obtaining a food license?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >   <p className="font-f-3 weight-500">To obtain a food license, the business must:</p>

                                       <ol>

                                          <li>

                                             Comply with FSSAI regulations.

                                          </li>


                                          <li>Provide valid documents (e.g., address proof, business detail).</li>


                                          <li> Have a Hygienic and safe food processing setup.</li>
                                          <li>Meet specific category requirements (e.g., manufacturing, retail).</li>


                                       </ol>
                                       Businesses also need to meet health and safety standards.
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8. Which type of FSSAI license is required for operating in multiple states?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          For a food business operating in multiple states, a Central FSSAI License is required. This license is applicable for large-scale operations, including food manufacturers, importers, and large retailers.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9. When can an FSSAI application be rejected?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">An FSSAI application can be rejected if:</p>

                                       <ol>

                                          <li>

                                          The provided documents are incorrect or incomplete.

                                          </li>


                                          <li>The business doesn't meet food safety standards.</li>


                                          <li> The address or premises doesn't meet the hygiene requirements.</li>
                                          <li>If the food business falls under an ineligible category for the applied license type.</li>


                                       </ol>
                                       Proper documentation and compliance are crucial.
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10. How can a customer file a complaint or grievance?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A customer can file a complaint or grievance by visiting the FSSAI website and using the complaint portal, contacting the customer support helpline for assistance, or emailing FSSAI or the relevant authorities with specific details of the issue. The complaints are thoroughly addressed to ensure food safety and compliance with regulations                                       </p>
                                    </div>
                                 </div>


                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>


         <Testimonials />



         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 ">
                     <div className="hadding7">

                        <h2 className="text-center">Why Choose Dm2Legal for FSSAI Registration?   </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient Registration</a></h4>
                           <p>With Dm2Legal, users can easily register online by simply providing their name, email ID, contact number, and selecting FSSAI registration services. After completing your online registration, our team will reach out to you and proceed with the necessary steps.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal has one of the largest online client bases, making us one of the best online platforms in India to help you get your FSSAI registration quickly. No matter where you are, we are ready to serve you online.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is renowned for providing comprehensive support and assistance to our clients. We offer ongoing support even after your registration is complete and value your feedback.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With 10 years of experience in the industry, we are highly skilled in providing FSSAI registration. By choosing us, you will benefit from working with the best experts, making the registration process smooth and efficient.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is committed to providing timely service. We understand the value of your time, so we begin working on your FSSAI registration process without delay.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We offer affordable services without compromising on quality. With every investment you make in us, we ensure that both your satisfaction and budget are our top priorities.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />

      </div>

   );
}
export default Foodlicence;